<template>
    <div>
      <section v-if="!initialLoading">
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table
                id="data-table-list-courses"
                class="table-hover-animation table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Precio</th>
                    <th>Products</th>
                    <th>Estado</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(offer, index) in offers"
                    v-bind:key="index"
                  >
            
                    <td>{{ offer.name }}</td>
                    <td>S./ {{ offer.price }}</td>
                    <td>
                      <ul>
                        <li v-for="product in offer.product_names">
                          {{product}}
                        </li>
                      </ul>
                    </td>
                    <td>
                      <el-tag
                        :type="offer.status == 0 ? 'danger' : 'success'"
                        class="mx-1"
                        effect="dark"
                      >
                        {{ offer.status == 0 ? 'No publicado' : 'Publicado' }}
                      </el-tag>
                    </td>
                    
                    <td>
                        <select @change="getOptionSelected(offer, $event)" v-model="optionSelected">
                            <option value="" disabled selected>Seleccione una acción</option>
                            <option v-for="item in options" :value="item.value">{{item.label}}</option>
                        </select>
                    </td>
                    <!-- <td class="align-content-center">
                      <el-select 
                        v-model="optionSelected" 
                        @change="getOptionSelected(course)" 
                        clearable 
                        size="mini" 
                        id="customize_select">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                      </el-select>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <custom-spinner v-else></custom-spinner>
  
      <custom-modal id="edit-offer-modal" color="primary" size="large" v-if="offerSelected">
        <template #title
          >Editar oferta <u> {{ offerSelected.name }} </u></template
        >
        <template #body>
          <form-offer-edit
            :offer="offerSelected"
          ></form-offer-edit>
        </template>
      </custom-modal>
  
      <!-- <custom-modal id="delete-course-modal" color="danger">
        <template #title
          >Borrar curso <u> {{ courseSelected.title }} </u></template
        >
        <template #body>¿Seguro que desea eliminar este curso?</template>
        <template #footer>
          <button type="button" class="btn btn-primary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" @click="deleteCourse(courseSelected.id)">
            Eliminar
          </button>
        </template>
      </custom-modal> -->
    </div>
  </template>
  <script>
  import moment from 'moment';
  import ModalComponent from '../ModalComponent.vue';
  import OfferEdit from './OfferEdit.vue';
  import CustomSpinner from '../../common/custom-spinner/CustomSpinner.vue';
  import language from '../../api/traduction_es';
  
  export default {
    props: {
      user: {
        type: Object,
        required: true,
      },
    },
  
    data() {
      return {
        initialLoading: false,
        moment: moment,
        offers: [],
        offer: [],
        offerSelected: [],
        options: [
          {
            value: '1',
            label: 'Editar',
          },
          {
            value: '2',
            label: 'Publicar/Ocultar',
          },
          // {
          //   value: '3',
          //   label: 'Eliminar',
          // },
        ],
        optionSelected: '',
      };
    },
    components: {
      'custom-modal': ModalComponent,
      'form-offer-edit': OfferEdit,
      'custom-spinner': CustomSpinner,
    },
  
    mounted() {
      this.listOffers();
    },
  
    methods: {
      loadDataTable() {
        $(document).ready( function () {
            $('#data-table-list-courses').DataTable(language);
        } );
      },
  
      
  
      listOffers: function () {
        this.initialLoading = true;
        axios.get(`/offers/list`).then((response) => {
          this.offers = response.data;
          this.initialLoading = false;
          this.loadDataTable();
        });
      },
      async changeStatus(offer){
        await axios.patch(`/offers/change-status/${offer.id}`).then((response) => {
          this.$message.success(response.data);
          this.listOffers();
        });
      },
  
      // listCategories() {
      //   axios
      //     .get(`/productos/tipo-producto`)
      //     .then((response) => {
      //       if (response.data.error) {
      //         this.message = 'Sin categorias registradas';
      //       } else {
      //         Object.keys(response.data).map((key) => {
      //           this.categories.push(response.data[key]);
      //         });
      //       }
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // },
  
      // listLevels() {
      //   axios/course/levels
      //     .get(``)
      //     .then((response) => {
      //       if (response.data.error) {
      //         this.message = 'Sin niveles registrados';
      //       } else {
      //         Object.keys(response.data).map((key) => {
      //           this.levels.push(response.data[key]);
      //         });
      //       }
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // },
  
      async deleteCourse(course_id) {
        const { data } = await axios.delete(`/course/delete/${course_id}`);
        const { status, courses } = await data;
        const response = (await status) == 'ok'
            ? this.$message.success('Se ha eliminado el curso correctamente')
            : await this.$message.success('Se ha eliminado el curso correctamente');
  
        if (!courses || courses.length == 0) {
          this.courses = [];
        }
        
        $('#delete-course-modal').modal('hide');
      },
  
      /**
       * Return data about the option selected in the table
       * @param {object} course - The course object selected
       */
      getOptionSelected(offer) {
        // La opcion se recupera de la variable optionSelected
        let option = this.optionSelected;
        switch (option) {
          case '1':
            this.offerSelected = offer;
            $('#edit-offer-modal').modal('show');
            this.optionSelected = '';
            break;
          case '2':
            this.changeStatus(offer);
            this.optionSelected = '';
            break;
          // case '3':
          //   this.courseSelected = course;
          //   $('#edit-course-modal').modal('show');
          //   this.optionSelected = '';
          //   break;
          default:
            console.log('Error');
            break;
        }
        // document.getElementById("select").value = "Seleccione";
      },
  
      /**
       * 0 -> registrado e inactivo
       * 1 -> en espera
       * 2 -> activo
       */
      async sendRequest(id) {
        const data = await axios.post(`/course/${id}/sendRequest`);
  
        switch (data.data) {
          case 'ok':
            this.$message.success('Curso enviado a revisión correctamente');
            break;
          case 'request':
            this.$message.warning('Ya se ha enviado el curso para su revisión');
            break;
          case 'empty':
            this.$message.warning('El curso debe tener al menos un módulo y una clase');
            break;
          case 'misconfigured':
            this.$message.warning('Configure la entrega del certificado');
            break;
          case 'signaturetemplate':
            this.$message.warning('Seleccione la plantilla y firma para el certificado');
            break;
          default:
            this.$message.warning('Error al validar datos');
            break;
        }
        this.listCourses();
      },
    },
  };
  </script>
  <style>
  .el-select {
    width: 80%;
  }
  .el-select .el-input .el-select__caret::before {
    content: '\e794';
  }
  
  #customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
  }
  </style>
  